/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/repos/bic-vue/src/components/common/SvgIcon.vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  tabindex: "0"
};
const _hoisted_2 = {
  class: "flex text-white text-xs items-center ml-2"
};
const _hoisted_3 = {
  id: "dropdownButton",
  class: "flex flex-col"
};
const _hoisted_4 = {
  key: 0,
  class: "font-semibold"
};
const _hoisted_5 = {
  class: "flex text-[10px]"
};
const _hoisted_6 = {
  key: 0,
  class: "ml-1 opacity-75"
};
const _hoisted_7 = {
  key: 1,
  class: "ml-1"
};
const _hoisted_8 = {
  class: "flex items-center px-2"
};
const _hoisted_9 = {
  key: 0,
  tabindex: "0",
  class: "mt-1 dropdown-content z-[100] menu p-2 shadow bg-base-300 rounded-box py-7"
};
const _hoisted_10 = {
  class: "flex flex-col gap-6"
};
const _hoisted_11 = {
  class: "flex flex-1 gap-6 h-full justify-around px-1 md:px-6"
};
const _hoisted_12 = {
  class: "flex-1 w-[200px] md:w-[250px]"
};
const _hoisted_13 = {
  class: "text-xl p-2 text-white"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "label cursor-pointer"
};
const _hoisted_16 = {
  class: "label-text"
};
const _hoisted_17 = ["checked"];
import { useCartStore } from '@/stores/cart';
import { useConfiguratorStore } from "@/stores/configurator";
import { useConfigurationStore } from "@/stores/configurationModule";
import { formatPrice } from '@/utils/common';
import { useWindowSize } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import { slugToLabelWithUnits } from '@/box/utils/unserialize-slug';
export default {
  __name: 'BoxConfigurationDropdown',
  setup(__props) {
    const {
      width: windowWidth
    } = useWindowSize();
    const cartStore = useCartStore();
    const {
      currentCartItem,
      boxQuantityOptions,
      basePrice,
      currentProductPrice
    } = storeToRefs(cartStore);
    const configurationStore = useConfigurationStore();
    const {
      setBoxQuantity
    } = configurationStore;
    const {
      boxWidth,
      boxLength,
      boxDepth,
      boxType,
      boxQuantity,
      product
    } = storeToRefs(configurationStore);
    const router = useRouter();
    const configuratorStore = useConfiguratorStore();
    const {
      mobileBreakpoint
    } = storeToRefs(configuratorStore);

    // const boxQuantityOptions = computed(() => {
    //   const numOfOptions = 10
    //   const step = 25

    //   return Array.from({ length: numOfOptions }, (_, i) => ({
    //     pcs: (i + 1) * step,
    //   }))
    // })

    // const productName = computed(() => product?.value?.name || '');
    // const productPrice = computed(() => product?.value?.price || 0);
    // const productLabel = computed(() => slugToLabel(product?.value?.variation_slug));

    // const initialBoxDimensionValue = `${boxWidth.value}″ x ${boxLength.value}″ x ${boxDepth.value}`;
    // const initialSelectedBoxType = boxType.value;
    const initialSelectedBoxQuantity = ref(boxQuantity.value);
    const isBoxTypeChanged = ref(false);
    const isBoxDimensionChanged = ref(false);
    const isBoxQuantityChanged = ref(false);
    const dropdownOpen = ref(false);

    // const selectedBoxType = ref(boxType.value);

    const selectedDimensions = ref({
      width: boxWidth.value,
      length: boxLength.value,
      depth: boxDepth.value
    });

    // @TODO: MOVE THIS
    const boxTypes = ['Shipping', 'Mailer'];

    // function setSelectedBoxType(type) {
    //   selectedBoxType.value = type;
    // }

    // function setSelectedDimensions(dimensions) {
    //   selectedDimensions.value = dimensions;
    // }

    function setSelectedBoxQuantity(quantity) {
      setBoxQuantity(Number(quantity.pcs));
    }

    // // @TODO: Fix, when we have set sizes for boxes this should be done trough ids?
    // // Also the box dimensions will be fetched the config
    // function dimensionsEquivalenceCheck(dimensions) {
    //   return (
    //     dimensions.width === selectedDimensions.value.width &&
    //     dimensions.length === selectedDimensions.value.length &&
    //     dimensions.depth === selectedDimensions.value.depth
    //   );
    // }

    function toggleDropdown() {
      dropdownOpen.value = !dropdownOpen.value;
    }
    function closeDropdown() {
      dropdownOpen.value = false;
    }

    // function handleBoxQuantity(value) {

    //   console.log("handleBoxQuantity", value);
    //   // set to store
    //   // initialSelectedBoxQuantity.value = getSelectedBoxQuantity.value.pcs;
    // }

    // async function handleBoxAndRedirect() {
    //   // if (getSelectedBoxQuantity.value.pcs) {
    //   //   handleBoxQuantity();
    //   // }
    //   await router.push({
    //     path: "/configurator",
    //     query: { type: selectedBoxType.value, width: selectedDimensions.value.width, length: selectedDimensions.value.length, depth: selectedDimensions.value.depth, quantity: selectedBoxQuantity.value },
    //   });
    //   location.reload();
    // }

    // watch(selectedDimensions, (val) => {
    //   if (val.width !== boxWidth.value || val.length !== boxLength.value || val.depth !== boxDepth.value) {
    //     isBoxDimensionChanged.value = true;
    //   }
    // });

    // watch(selectedBoxType, (val) => {
    //   if (val !== boxType.value) {
    //     isBoxTypeChanged.value = true;
    //   }
    // });

    return (_ctx, _cache) => {
      const _component_SvgIcon = __unplugin_components_0;
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["dropdown dropdown-bottom md:dropdown-end", {
          'dropdown-open': _unref(dropdownOpen)
        }])
      }, [_createElementVNode("label", _hoisted_1, [_createElementVNode("div", {
        class: "flex cursor-pointer",
        onClick: toggleDropdown
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_unref(windowWidth) >= _unref(mobileBreakpoint) ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(slugToLabelWithUnits)(_unref(product)?.variation_slug)), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('configurator.offer1')) + " " + _toDisplayString(_unref(boxQuantity)), 1), _unref(basePrice) && _unref(windowWidth) >= _unref(mobileBreakpoint) && _unref(currentProductPrice) !== _unref(basePrice) ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createElementVNode("del", null, _toDisplayString(_unref(formatPrice)(_unref(basePrice))), 1)])) : _createCommentVNode("", true), _unref(currentProductPrice) && _unref(windowWidth) >= _unref(mobileBreakpoint) ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(formatPrice)(_unref(currentProductPrice))) + " " + _toDisplayString(_ctx.$t('configurator.offer2')), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_SvgIcon, {
        svgSymbolId: "chevron-down",
        class: _normalizeClass(["dropdown-chevron w-5 h-5 mt-1", {
          'chevron-up': _unref(dropdownOpen)
        }])
      }, null, 8, ["class"])])])])]), _unref(dropdownOpen) ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.$t('configurator.boxQuantity')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(boxQuantityOptions), (qty, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", {
          class: "hover:bg-base-100 pl-1",
          onClick: $event => setSelectedBoxQuantity(qty)
        }, [_createElementVNode("label", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(qty.pcs) + " pcs " + _toDisplayString(_unref(formatPrice)(qty.price) ? `(${_unref(formatPrice)(qty.price)})` : ''), 1), _createElementVNode("input", {
          type: "radio",
          name: "radio-quantity",
          class: "radio checked:bg-purple-600",
          checked: qty.pcs === Number(_unref(boxQuantity))
        }, null, 8, _hoisted_17)])], 8, _hoisted_14)]);
      }), 128))])])])])) : _createCommentVNode("", true)], 2)), [[_unref(vOnClickOutside), closeDropdown]]);
    };
  }
};